import AxiosPermisos  from './../../axiosPermisos'

import {
  path
} from './path'

import {
  map_query
} from '@/core/functions/map-path-query'

async function storeGES (data = {}) {
  return await AxiosPermisos.postSendFile(path.store, true, data ,'v2')
}

async function editGES (id, data = {}) {
  return await AxiosPermisos.postSendFile(`${path.edit}/${id}`, true, data ,'v2')
}

async function uploadEmployees (data) {
  return await AxiosPermisos.postSendFile(`${path.uploadEmployees}`, true, data ,'v2')
}

async function indexEmployeesGES (id = 0, data = {}) {
  const url = path.get.concat(`/${id}${path.employees.concat(map_query(data))}`)
  return await AxiosPermisos.get(url, true, 'v2')
}

async function searchEmployeeByLocation (data) {
  let params = '?'
  if (data.search) {
    params += 'search=' + data.search + '&';
  }
  return await AxiosPermisos.get(path.employeesByLocation + params, true, 'v2');
}

async function saveEmployeesIpt (data) {
  return await AxiosPermisos.post(path.saveEmployeesIpt, true, data ,'v2')
}

async function getEmployeesIpt (id, data) {
  return await AxiosPermisos.get(`${path.getEmployeesIpt}/${id}/employees`, true, 'v2', data);
}

async function getQuestionsIpt (idGes) {
  return await AxiosPermisos.get(`${path.getQuestion}/${idGes}`, true, 'v2')
}

async function getAnswersIpt (id) {
  return await AxiosPermisos.get(`${path.getAnswers}/${id}`, true, 'v2')
}

async function saveQuestion (id, data) {
  return await AxiosPermisos.post(`${path.saveQuestion}/${id}`, true, data, 'v2')
}

async function dowloanFileIpt (id, data) {
  return await AxiosPermisos.postSendFile(`${path.dowloanFileIpt}/${id}/upload-file`, true, data, 'v2')
}

async function getQuestionRisk (idGes) {
  return await AxiosPermisos.get(`${path.getQuestionRisk}/${idGes}/questions`, true, 'v2')
}

async function saveQuestionRisk (id, data) {
  return await AxiosPermisos.post(`${path.saveQuestionRisk}/${id}`, true, data, 'v2')
}

async function answersRisk (idGes) {
  return await AxiosPermisos.get(`${path.answersRisk}/${idGes}/answers`, true, 'v2')
}

async function historyRisk (idGes) {
  return await AxiosPermisos.get(`${path.historyRisk}/${idGes}/history`, true, 'v2')
}

async function editQuestionRisk (id, data) {
  return await AxiosPermisos.put(`${path.editRisk}/${id}`, true, data, 'v2')
}

export {
  storeGES,
  editGES,
  indexEmployeesGES,
  searchEmployeeByLocation,
  uploadEmployees,
  saveEmployeesIpt,
  getEmployeesIpt,
  getQuestionsIpt,
  saveQuestion,
  dowloanFileIpt,
  getAnswersIpt,
  getQuestionRisk,
  saveQuestionRisk,
  answersRisk,
  editQuestionRisk,
  historyRisk
}